/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const levelStatsV2Schema = z.object({
  level: z.number(),
  total: z.number(),
  expired: z.number(),
  lastPass: z.number(),
  lastFail: z.number(),
});

export type ILevelStatsV2 = z.infer<typeof levelStatsV2Schema>;
